import { ADD_EMP, EDIT_EMP,
   GET_EMP, SEARCH_EMP, DELETE_EMP, UPLOAD_BULK_EMP } from "./constant";

export function addEmpRequest(data) {
  return {
    type:ADD_EMP.PENDING,
    data
  }
}

export function addEmpSuccess(data) {
  return {
    type:ADD_EMP.SUCCESS,
    data
  }
}

export function addEmpError(err) {
  return{
    type:ADD_EMP.ERROR,
    err
  }
}

export function  editEmpReqest(data) {
  return {
    type:EDIT_EMP.PENDING,
    data
  }
}

export function  editEmpSuccess(data) {
  return {
    type:EDIT_EMP.SUCCESS,
    data
  }
}

export function  editEmpError(err) {
  return {
    type:EDIT_EMP.ERROR,
    err
  }
}

export function getEmpRequest(data) {
  return {
     type:GET_EMP.PENDING,
     data
  }
}

export function getEmpSuccess(data) {
  return {
    type:GET_EMP.SUCCESS,
    data
  }
}
export function getEmpError(err) {
  return {
    type:GET_EMP.ERROR,
    err
  }
}

export function  searchEmpRequest(data) {
  return {
    type:SEARCH_EMP.PENDING,
    data
  }
}

export function searchEmpSuccess(data) {
  return {
    type:SEARCH_EMP.SUCCESS,
    data,
  }
}

export function searchEmpError(err) {
  return{
    type:SEARCH_EMP.ERROR,
    err
  }
}

export function  deleteEmpRequest(data) {
  return {
    type:DELETE_EMP.PENDING,
    data
  }
}

export function deleteEmpSuccess(data) {
  return {
    type:DELETE_EMP.SUCCESS,
    data,
  }
}

export function deleteEmpError(err) {
  return {
    type:DELETE_EMP.ERROR,
    err
  }
}

export function uploadBulkEmpRequest(data){
  return {
    type:UPLOAD_BULK_EMP.PENDING,
    data
  }
}

export function uploadBulkEmpSuccess(data){
  return {
    type:UPLOAD_BULK_EMP.SUCCESS,
    data
  }
}

export function uploadBulkEmpError(err){
  return {
    type:UPLOAD_BULK_EMP.ERROR,
    err
  }
}
